// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fG5MG","controls":"styles_controls__1m6Ts","charLimit":"styles_charLimit__39qdn","input":"styles_input__s_Kxk","send":"styles_send__2J5Dl"};